var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.2392,
    cy: 10.8545,
    r: 10.127,
    fill: "#EF4444"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0638 6.01479C11.8265 7.80615 11.5761 9.68972 11.3256 11.5865C11.2597 12.087 11.2465 12.6007 11.1147 13.0749C11.0488 13.312 10.7588 13.4964 10.5743 13.6939C10.3766 13.4964 10.047 13.312 10.0075 13.088C9.66479 10.7171 9.34844 8.34619 9.05846 5.97527C8.95301 5.06642 9.63843 4.3288 10.5216 4.30245C11.3915 4.27611 12.077 5.00056 12.0638 6.01479Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.721 15.5641C11.721 16.1964 11.1806 16.7364 10.5479 16.7364C9.91522 16.7364 9.40115 16.1964 9.40115 15.551C9.40115 14.8924 9.91522 14.3918 10.5611 14.3918C11.207 14.3918 11.721 14.9187 11.721 15.5641Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.e39f3192995cd7804b705e67d863e2d0.svg";
export { ForwardRef as ReactComponent };